export const BULLET = '\u2022';
